import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { FsAddressModule } from '@firestitch/address';
import { FsCheckboxGroupModule } from '@firestitch/checkboxgroup';
import { FsDialogModule } from '@firestitch/dialog';
import { FsFormModule } from '@firestitch/form';
import { FsSkeletonModule } from '@firestitch/skeleton';

import { AutofocusModule } from '@libs/autofocus';

import {
  AddressComponent,
  ContactInfoComponent,
  CreateComponent,
  DiseasesComponent,
  InviteComponent,
  LogoComponent,
  OrganizationNameComponent,
  ProgressComponent,
} from './components';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatSelectModule,
    MatCheckboxModule,

    FsDialogModule,
    FsFormModule,
    FsSkeletonModule,
    FsAddressModule,
    FsCheckboxGroupModule,

    AutofocusModule,
  ],
  declarations: [
    CreateComponent,
    OrganizationNameComponent,
    AddressComponent,
    ContactInfoComponent,
    LogoComponent,
    ProgressComponent,
    DiseasesComponent,
    InviteComponent,
  ],
  exports: [
    CreateComponent,
  ],
})
export class CreateModule { }
